import { render, staticRenderFns } from "./v-message.vue?vue&type=template&id=71f8d990&scoped=true&"
import script from "./v-message.vue?vue&type=script&lang=ts&"
export * from "./v-message.vue?vue&type=script&lang=ts&"
import style0 from "./v-message.vue?vue&type=style&index=0&id=71f8d990&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f8d990",
  null
  
)

export default component.exports